import { useQuery } from "@tanstack/react-query";

import { get } from "../helpers/HTTP";

import type { Workspace } from "../types";

async function getWorkspacesRequest(): Promise<Workspace[]> {
  return (await get(`workspaces`)).workspaces;
}

export default function useWorkspaces({
  disableQuery,
}: {
  disableQuery?: boolean;
} = {}) {
  const { data: workspaces, refetch: refetchWorkspaces } = useQuery({
    queryKey: ["workspaces"],
    queryFn: getWorkspacesRequest,
    refetchOnMount: false,
    enabled: !disableQuery,
  });

  return {
    workspaces,
    refetchWorkspaces,
  };
}
